import React from "react";
import { BConnectedButton } from "./BConnectedButton";
import { useUser } from "components/hooks/useUser";
import { BCalPopover } from "./Popovers/BCalPopover";

export function BCalButton() {
  const { badges: { bcal: { count } = {} } = {} } = useUser(
    (user) => user.bconnected
  );

  return (
    <BConnectedButton count={count} service="Cal">
      <BCalPopover />
    </BConnectedButton>
  );
}
